export function useBrandSearch(data: any) {
  const search = ref('');
  const filterBrands = (value: string) => { search.value = value; };
  const brandOptions = computed(() => (data.value?.uogorod_brands || []).filter((brand: any) =>
    [brand.title, ...(Array.isArray(brand.synonyms) ? brand.synonyms : [])]
      .some(name => String(name).toLocaleLowerCase().includes(search.value.toLocaleLowerCase().trim()))));
  return { filterBrands, brandOptions };
}
